import LanetalkLogo from '@/assets/lanetalk-logo.svg?react';
import LivescoringLogo from '@/assets/livescoring-logo.svg?react';

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <LanetalkLogo className="h-[35.46px] w-[125px] md:h-[50px] md:w-[176px]" />
      <LivescoringLogo className="h-[25px] w-[122px] md:h-[26px] md:w-[147px]" />
    </div>
  );
};

export default Logo;
